import React from 'react';
import { useChatStore } from '../../../store/chat_store';
import { formatDistanceToNow } from 'date-fns';

const ChatHeader = () => {
  const { activeConversation, onlineUsers } = useChatStore();

  if (!activeConversation) return null;
  const { otherUser, otherUserId } = activeConversation;
  
  const userStatus = onlineUsers[otherUserId];
  const isOnline = userStatus?.status === 'online';
  
  let statusText = 'Offline';
  if (isOnline) {
    statusText = 'Online';
  } else if (userStatus?.lastSeen) {
    statusText = `Last seen ${formatDistanceToNow(new Date(userStatus.lastSeen), { addSuffix: true })}`;
  }

  return (
    <div className="flex items-center justify-between p-4 border-b border-gray-200 bg-white">
      <div className="flex items-center">
        <div className="relative">
          <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-semibold">
            {otherUser?.profile_image ? (
              <img src={otherUser.profile_image} alt={otherUser.name} className="w-full h-full rounded-full object-cover" />
            ) : (
              otherUser?.name?.charAt(0).toUpperCase()
            )}
          </div>
          {isOnline && (
            <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 border-2 border-white rounded-full"></div>
          )}
        </div>
        <div className="ml-3">
          <h2 className="text-lg font-semibold text-gray-800">{otherUser?.name}</h2>
          <p className="text-xs text-gray-500">{statusText}</p>
        </div>
      </div>
      
    </div>
  );
};

export default ChatHeader;
